module.exports = {
  activeLinkDashboard: "dashboard",
  activeLinkProfile: "profile",
  clientDashboard: "/client-dashboard",
  clientProfile: "/client-profile",
  clientAddNewRequirement: "/client-add-new-requirement",
  clientdPreviewRequirement: "/client-preview-requirement",
  agencyDashboard: "/agency-dashboard",
  agencyDashboardRequirementDetail: "/agency-dashboard-requirement-detail",
  agencyDashboardClientProfile: "/agency-dashboard-client-profile",
  agencyProfile: "/agency-profile",
  superAdminDashboard: "/super-admin-dashboard",
  superAdminProfile: "/super-admin-profile",
  superAdminClientDetails: "/super-admin-client-details",
  superAdminAgencyDetails: "/super-admin-agency-details",
  superAdminDashboardRequirementDetails:
    "/super-admin-dashboard-requirement-details",
  addNewClient: "/add-new-client",
  addNewAgency: "/add-new-agency",
};
